/* eslint-disable max-len */
const Pending = () => (
  <svg id="Art" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2">
    <polyline points="20.4 1.76 20.4 6.57 15.59 6.57" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M22,12c0,5.52-4.48,10-10,10S2,17.52,2,12,6.48,2,12,2c3.46,0,6.52,1.76,8.31,4.44" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <g>
      <line x1="7.5" y1="12" x2="7.5" y2="12" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <line x1="12" y1="12" x2="12" y2="12" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <line x1="16.5" y1="12" x2="16.5" y2="12" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </g>
  </svg>
);

export default Pending;
